export default __webpack_public_path__ + "static/image14-51440dcac3a8228c7f3f79c5d2b4eb37.gif";